import {
    CustomSeriesPricePlotValues,
    ICustomSeriesPaneView,
    PaneRendererCustomData,
    Time,
    WhitespaceData
} from 'lightweight-charts'
import { defaultPandFOptions, PandFSeriesOptions } from './options'
import { PandFSeriesRenderer } from './renderer'
import { PandFData } from './data'

export class PandFSeries<TData extends PandFData>
    implements ICustomSeriesPaneView<Time, TData, PandFSeriesOptions> {
    _renderer: PandFSeriesRenderer<TData>

    constructor() {
        this._renderer = new PandFSeriesRenderer()
    }

    priceValueBuilder(plotRow: TData): CustomSeriesPricePlotValues {
        return [plotRow.high, plotRow.close, plotRow.open, plotRow.low]
    }

    isWhitespace(data: TData | WhitespaceData): data is WhitespaceData {
        return (data as Partial<TData>).close === undefined && (data as Partial<TData>).open === undefined
    }

    renderer(): PandFSeriesRenderer<TData> {
        return this._renderer
    }

    update(
        data: PaneRendererCustomData<Time, TData>,
        options: PandFSeriesOptions
    ): void {
        this._renderer.update(data, options)
    }

    defaultOptions() {
        return defaultPandFOptions
    }
}
